import axios from "axios";

const apiHighProcess = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_HIGHPROCESS_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8089",
});

export default apiHighProcess;
